<template>
	<div>
		<page-header :title="title"></page-header>
		<form @submit.prevent="gravar">
			<div class="modal-body">
				<div class="form-horizontal">
					<vue-element-loading :active="isActive" spinner="bar-fade-scale"
						color="#428BCA"></vue-element-loading>
					<div class="form-group">
						<select-form v-model="form.geracao" :value="form.geracao" name="Geração"
							url="/geracao" id="nome" titulo="nome" layout="true" optionText="Selecione"></select-form>
					</div>
					<div class="page-header">
						<h1>Pokémon Principal</h1>
					</div>
					<input-form-text textInput="Número Pokémon" :required="true" v-model="form.pokedex"
						:value="form.pokedex"></input-form-text>
					<input-form-text textInput="Nome Pokémon" :required="true" v-model="form.name"
						:value="form.name"></input-form-text>
					<div class="page-header">
						<h1>Família Pokémon</h1>
					</div>
					<input-form-text textInput="Números Pokémons" :required="true" v-model="form.dex"
						:value="form.dex"></input-form-text>
					<input-form-text textInput="Nomes Pokémons" v-model="form.name_dex"
						:value="form.name_dex"></input-form-text>
					<input-form-text textInput="Shiny" :required="true" v-model="form.shiny"
						:value="form.shiny"></input-form-text>
					<div class="page-header">
						<h1>Detalhes</h1>
					</div>
					<input-form-text textInput="Categoria" :required="true" v-model="form.categoria"
						:value="form.categoria"></input-form-text>
					<input-form-text textInput="Categoria Ing" :required="true" v-model="form.categoria_en"
						:value="form.categoria_en"></input-form-text>
					<input-form-text textInput="Tipagem" :required="true" v-model="form.tipo"
						:value="form.tipo"></input-form-text>
					<input-form-text textInput="Ligas" v-model="form.rec_ligas"
						:value="form.rec_ligas"></input-form-text>
					<input-form-text textInput="Uso" v-model="form.rec_uso"
						:value="form.rec_uso"></input-form-text>
					<input-form-text textInput="Variação" v-model="form.var_pokemon"
						:value="form.var_pokemon"></input-form-text>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="text">Descrição</label>
						<div class="col-sm-6">
							<textarea class="form-control" v-model="form.text" placeholder="Descrição" v-autosize="v-autosize"></textarea>
						</div>
					</div>
					<div class="form-group">
						<label class="col-sm-3 control-label no-padding-right" for="text">Descrição Ing</label>
						<div class="col-sm-6">
							<textarea class="form-control" v-model="form.text_en" placeholder="Descrição" v-autosize="v-autosize"></textarea>
						</div>
					</div>
					<div class="page-header">
						<h1>Reide</h1>
					</div>
					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Reide 1</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Nota" v-model="form.raid_1_nota"
						:value="form.raid_1_nota"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.raid_1_golpes"
						:value="form.raid_1_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Reide 2</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Nota" v-model="form.raid_2_nota"
						:value="form.raid_2_nota"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.raid_2_golpes"
						:value="form.raid_2_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Reide 3</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Nota" v-model="form.raid_3_nota"
						:value="form.raid_3_nota"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.raid_3_golpes"
						:value="form.raid_3_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Reide 4</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Nota" v-model="form.raid_4_nota"
						:value="form.raid_4_nota"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.raid_4_golpes"
						:value="form.raid_4_golpes"></input-form-text>
						</div>
					</div>

					<div class="page-header">
						<h1>PVP</h1>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Liga 1</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Liga" v-model="form.liga_1"
						:value="form.liga_1"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.liga_1_golpes"
						:value="form.liga_1_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Liga 2</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Liga" v-model="form.liga_2"
						:value="form.liga_2"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.liga_2_golpes"
						:value="form.liga_2_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Liga 3</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Liga" v-model="form.liga_3"
						:value="form.liga_3"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.liga_3_golpes"
						:value="form.liga_3_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Liga 4</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Liga" v-model="form.liga_4"
						:value="form.liga_4"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.liga_4_golpes"
						:value="form.liga_4_golpes"></input-form-text>
						</div>
					</div>

					<div class="widget-box">
						<div class="widget-header widget-header-blue widget-header-flat">
							<h4 class="widget-title lighter">Liga 5</h4>
						</div>
						<div class="widget-body mt-5">
							<input-form-text textInput="Liga" v-model="form.liga_5"
						:value="form.liga_5"></input-form-text>
						<input-form-text textInput="Golpes" v-model="form.liga_5_golpes"
						:value="form.liga_5_golpes"></input-form-text>
						</div>
					</div>
					<div class="page-header">
						<h1>Dia Comunitário</h1>
					</div>
					<div class="widget-box">
						<input-form-text textInput="DC" v-model="form.dc"
						:value="form.dc"></input-form-text>
						<input-form-text textInput="DC Data" v-model="form.dc_dt"
						:value="form.dc_dt"></input-form-text>
						<input-form-text textInput="Golpe" v-model="form.dc_golpe"
						:value="form.dc_golpe"></input-form-text>
						<input-form-text textInput="Categoria" v-model="form.dc_categoria"
						:value="form.dc_categoria"></input-form-text>
						<input-form-text textInput="Categoria" v-model="form.dc_categoria_en"
						:value="form.dc_categoria_en"></input-form-text>
					</div>
					<div class="page-header">
						<h1>Lendários</h1>
					</div>
					<div class="widget-box">
						<input-form-text textInput="Golpe Legacy" v-model="form.lendario_legacy"
						:value="form.lendario_legacy"></input-form-text>
						<input-form-text textInput="Counters" v-model="form.lendario_counters"
						:value="form.lendario_counters"></input-form-text>
					</div>
				</div>
			</div>
			<footer-button :disabled="isActiveBtn"></footer-button>
		</form>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import InputFormText from '@/components/form/InputForm'
import FooterButton from '@/components/form/FooterButton'
import SelectForm from '@/components/form/SelectForm'
import Permission from '@/mixins/Permission'
import req from '@/components/request'
import { sucesso, erro } from '@/components/Message'

export default {
	components: {
		PageHeader,
		InputFormText,
		FooterButton,
		SelectForm,
		VueElementLoading,
	},
	mixins: [Permission],
	computed: {
		...mapGetters([
			'user'
		])
	},
	data() {
		return {
			title: 'Pokémons',
			form: {
				geracao: '',
				pokedex: '',
				shiny: '',
				name: '',
				dex: '',
				name_dex: '',
				categoria: '',
				categoria_en: '',
				tipo: '',
				rec_ligas: '',
				rec_uso: '',
				var_pokemon: '',
				text: '',
				text_en: '',
				raid_1_nota: '',
				raid_2_nota: '',
				raid_3_nota: '',
				raid_4_nota: '',
				raid_1_golpes: '',
				raid_2_golpes: '',
				raid_3_golpes: '',
				raid_4_golpes: '',
				liga_1_golpes: '',
				liga_2_golpes: '',
				liga_3_golpes: '',
				liga_4_golpes: '',
				liga_5_golpes: '',
				liga_1: '',
				liga_2: '',
				liga_3: '',
				liga_4: '',
				liga_5: '',
				dc: '',
				dc_dt: '',
				dc_golpe: '',
				dc_categoria: '',
				dc_categoria_en: '',
				lendario_legacy: '',
				lendario_counters: ''
			},
			money: {
				decimal: ',',
				thousands: '.',
				prefix: '',
				suffix: '',
				precision: 2,
				masked: false
			},
			allImages: [],
			isActiveBtn: false,
			isActive: false
		}
	},
	methods: {
		...mapActions([
			'getLogsTotal'
		]),
		async gravar() {
			this.isActive = true
			this.isActiveBtn = true
			const body = this.form
			//this.setVersion()
			if (this.$route.params.id) {
				await req(`/v1/pokemons/${this.$route.params.id}`, 'put', body).catch(() => {
					erro()
				})
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/app/pokemons')
			} else {
				await req('/v1/pokemons', 'post', body).catch(() => {
					erro()
				})
				this.isActive = false
				sucesso('Atualizado...')
				this.getLogsTotal(this.user.id)
				this.$router.push('/app/pokemons')
			}
			this.isActiveBtn = false
		},
		async setVersion() {
			await req('/versao/1', 'put', {
				title: Date.now()
			})
		},
		async getDados() {
			const resp = await req(`/v1/pokemons/${this.$route.params.id}`).catch(() => {
				erro()
			})
			this.form.geracao = resp.geracao
			this.form.pokedex = resp.pokedex
			this.form.shiny = resp.shiny
			this.form.name = resp.name
			this.form.dex = resp.dex
			this.form.name_dex = resp.name_dex
			this.form.categoria = resp.categoria
			this.form.categoria_en = resp.categoria_en
			this.form.tipo = resp.tipo
			this.form.rec_ligas = resp.rec_ligas
			this.form.rec_uso = resp.rec_uso
			this.form.var_pokemon = resp.var_pokemon
			this.form.text = resp.text
			this.form.text_en = resp.text_en
			this.form.raid_1_nota = resp.raid_1_nota
			this.form.raid_2_nota = resp.raid_2_nota
			this.form.raid_3_nota = resp.raid_3_nota
			this.form.raid_4_nota = resp.raid_4_nota
			this.form.raid_1_golpes = resp.raid_1_golpes
			this.form.raid_2_golpes = resp.raid_2_golpes
			this.form.raid_3_golpes = resp.raid_3_golpes
			this.form.raid_4_golpes = resp.raid_4_golpes
			this.form.liga_1_golpes = resp.liga_1_golpes
			this.form.liga_2_golpes = resp.liga_2_golpes
			this.form.liga_3_golpes = resp.liga_3_golpes
			this.form.liga_4_golpes = resp.liga_4_golpes
			this.form.liga_5_golpes = resp.liga_5_golpes
			this.form.liga_1 = resp.liga_1
			this.form.liga_2 = resp.liga_2
			this.form.liga_3 = resp.liga_3
			this.form.liga_4 = resp.liga_4
			this.form.liga_5 = resp.liga_5
			this.form.dc = resp.dc
			this.form.dc_dt = resp.dc_dt
			this.form.dc_golpe = resp.dc_golpe
			this.form.dc_categoria = resp.dc_categoria
			this.form.dc_categoria_en = resp.dc_categoria_en
			this.form.lendario_legacy = resp.lendario_legacy
			this.form.lendario_counters = resp.lendario_counters
			this.isActive = false
		},
		verifPermissao() {
			if (this.$route.params.id) {
				if (!this.ACTION.e) {
					this.$router.push('/erro')
				}
			} else {
				if (!this.ACTION.c) {
					this.$router.push('/erro')
				}
			}
		}
	},
	mounted() {
		this.verifPermissao()
		if (this.$route.params.id) {
			this.isActive = true
			this.getDados()
		}
	}
}
</script>

<style lang="stylus" scoped>

</style>
